'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_NoSpinner$() {
}
export { $c_Lpresto_NoSpinner$ as $c_Lpresto_NoSpinner$ };
$p = $c_Lpresto_NoSpinner$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_NoSpinner$;
/** @constructor */
function $h_Lpresto_NoSpinner$() {
}
export { $h_Lpresto_NoSpinner$ as $h_Lpresto_NoSpinner$ };
$h_Lpresto_NoSpinner$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 591106296;
});
$p.l = (function() {
  return "NoSpinner";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "NoSpinner";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.afp = (function() {
});
$p.afr = (function() {
});
$p.a3T = (function(cause) {
});
$p.a3E = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.Sn = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au(false);
});
var $d_Lpresto_NoSpinner$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_NoSpinner$, "presto.NoSpinner$", ({
  Mw: 1,
  eb: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_NoSpinner$ as $d_Lpresto_NoSpinner$ };
var $n_Lpresto_NoSpinner$;
function $m_Lpresto_NoSpinner$() {
  if ((!$n_Lpresto_NoSpinner$)) {
    $n_Lpresto_NoSpinner$ = new $c_Lpresto_NoSpinner$();
  }
  return $n_Lpresto_NoSpinner$;
}
export { $m_Lpresto_NoSpinner$ as $m_Lpresto_NoSpinner$ };
//# sourceMappingURL=presto.-No-Spinner$.js.map
